var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-container",
    { staticClass: "ozaria-modal", attrs: { role: "dialog", tabindex: "0" } },
    [
      _vm._t("close-icon"),
      _vm._v(" "),
      _c("div", { staticClass: "ozaria-modal-content" }, [
        _c(
          "div",
          { staticClass: "ozaria-modal-header" },
          [_vm._t("header")],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ozaria-modal-body" }, [_vm._t("body")], 2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ozaria-modal-footer" },
          [_vm._t("footer")],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }